import { Action, createReducer, on } from '@ngrx/store';

import { ProceedButtonActions } from '@modules/booking/store/proceed-button/proceed-button.actions';

export interface ProceedButtonState {
  display: boolean;
}

const initialState: ProceedButtonState = {
  display: false,
};

const proceedButtonReducer = createReducer(
  initialState,
  on(
    ProceedButtonActions.display,
    (state): ProceedButtonState => ({
      ...state,
      display: true,
    })
  ),
  on(
    ProceedButtonActions.hide,
    (state): ProceedButtonState => ({
      ...state,
      display: false,
    })
  )
);

export function reducer(state: ProceedButtonState | undefined, action: Action) {
  return proceedButtonReducer(state, action);
}
